//
//
//
//

export default {
  name: "userobject",
  data() {
    return {
      userinfo: undefined,
      userdata:undefined
    }
  },
  methods: {
    update_user_info: function () {
      xx.requests.get('/app/user/info', {
        params: {}
      }).then((response) => {
        var message_notify = response.data.message_notify;
        if (message_notify) {
          num = parseInt(message_notify.num);
        }
        console.log("message_notify:", message_notify);
        this.message_notify = message_notify;
        if (this.message_notify.num <= 0) {
          this.message_notify.num = undefined;
        }
      }).catch(function (error) {

      });
    },
    is_login: function () {
      return this.userdata && this.userdata.username;
    },
    buy_discount: function () {
      if (this.is_login()) {
        var vip_degree = this.$vip_degree_conf[this.userdata.vip_degree];
        if (vip_degree) {
          return vip_degree;
        }
      }
    },
    this_vip_degree() {
      var vip_conf = undefined;
      if (this.$vip_degree_conf) {
        vip_conf = this.$vip_degree_conf[this.userdata.vip_degree];
      }
      if (!vip_conf) {
        vip_conf = {
          "name": "未开通VIP",
          "discount": 1,
          'degree': "vip0"
        };
      }
      return vip_conf
    },
  },
  created: function () {
    this.userdata = this.$store.state.user.userinfo;
    console.log("userobject created:", this.userdata);
    if (!this.userdata)
      this.userdata = {};

    this.userdata.is_vip = false;
    /*if (this.userdata.vip && this.userdata.vip > this.init_data.now_time) {
      this.userdata.is_vip = true;
    } else {
      this.userdata.vip_degree = 'vip0';
    }*/
    if (!this.userdata.gold) {
      this.userdata.gold = 0;
    }
    this.userinfo = this.userdata
  }
}
